import styles from './CrpInfo.module.scss';

const CrpInfo = () => {
    return (
        <div className={styles.container}>
            <h3>Controlling person</h3>
            <p>
                The controlling person(s) of a company are the UBOs (Ultimate
                Beneficial Owner). If there is no UBO please list the management
                of the company.
            </p>
            <h3>Explanations about the type of persons to be listed</h3>
            <p>
                Depending on the company, there can be various controlling
                persons:
            </p>
            <ul>
                <li data-isolate>
                    <span className={styles.strong}>
                        Ultimate Beneficial Owner:
                    </span>
                    &nbsp;UBO stands for &quot;Ultimate Beneficial Owner&quot;
                    in the context of a company. It refers to the individual(s)
                    who ultimately owns or controls a company, either directly
                    or indirectly, and has the ability to make decisions about
                    the company&apos;s operations, policies, and financial
                    transactions. By identifying the true owners or controllers
                    of a company, we can help prevent illicit activities such as
                    money laundering, fraud, and corruption.
                </li>
                <li data-isolate>
                    <span className={styles.strong}>Board of Directors:</span>
                    &nbsp;Members of the Board of Directors are individuals
                    appointed or elected by a company&apos;s shareholders or
                    stakeholders to oversee the management and direction of the
                    company. The board of directors is responsible for making
                    strategic decisions, setting policies, and providing
                    guidance and supervision to the management team of the
                    company.
                </li>
                <li data-isolate>
                    <span className={styles.strong}>Executive Board:</span>
                    &nbsp;The executive board of a company consists of senior
                    managers, such as the CEO, CFO, and other executives who are
                    responsible for overseeing the day-to-day operations and
                    implementing strategic decisions made by the board of
                    directors.
                </li>
                <li data-isolate>
                    <span className={styles.strong}>Shareholder:</span>
                    &nbsp;Shareholders are individuals who own shares in a
                    company. Shareholders are often investors who contribute
                    capital to the company and, in return, hold ownership stakes
                    representing their ownership interests.
                </li>
            </ul>
            <h3>Authorized person</h3>
            <p>
                Who is allowed to sign on behalf of the company according to
                commercial register. List all authorized individuals here.
            </p>
            <h6>What is an authorized person?</h6>
            <p data-isolate>
                An <span className={styles.strong}>authorized person</span> of a
                company is an individual who has been granted legal authority or
                permission to act on behalf of the company. Authorized persons
                in this context are typically listed in the commercial registry.
            </p>
            <h3>Contract signer</h3>
            <p>List who will sign the contract with amnis</p>
            <h6>What do we mean with contract signer?</h6>
            <p data-isolate>
                In this context, a&nbsp;
                <span className={styles.strong}>contract signer</span> is the
                person or persons who will actually sign the contract with
                amnis. Not all legally authorized individuals need to be listed,
                but only the person(s) signing this specific contract.
                Generally, one or two persons are designated for this role.
            </p>
            <h3>Administrator</h3>
            <p>
                Administrator in this context is the user who will have admin
                access rights to the amnis application. The administrator can be
                edited or changed later.
            </p>
            <h6>What&apos;s the role of administrators?</h6>
            <p data-isolate>
                Users with <span className={styles.strong}>administrator</span>
                &nbsp;rights will have access to the amnis application.
                Depending on the settings (which can be edited in the
                application and granted individually) they will have the rights
                to perform some or all of the amnis functions within the app
                such as adding, editing or deleting users, perform currency
                exchanges, execute payments or issuing and managing debit cards.
            </p>
            <p>
                Note that during onboarding&nbsp;
                <span className={styles.strong}>only one administrator</span>
                &nbsp;can be defined. Administrators can be edited, changed or
                added once the onboarding process is finished if required.
            </p>
        </div>
    );
};

export default CrpInfo;
